import { IProzessDto } from "../../../api/backend-api-v7";
import {
  ProzessEventOperationTypes,
  ProzessInputData,
} from "../../../store/prozess-events/prozess-events.actions";

export interface ConnectedDispatch {
  onChanged: (prozessInputData: ProzessInputData) => void;
  givenDataApplied: (workflowId: number) => void;
  setCanProcessMultipleProzessEvents: (canProcess: boolean) => void;
}

export interface ConnectedState {
  givenData: ProzessInputData | undefined;
  prevRecordId: string;
  isManuallyEmpty: boolean | undefined;
  shouldCreateProzessEventForMultipleProzess: boolean;
  editedValue: string | string[] | undefined;
  isEditing: boolean;
  isProzessEventEditable: boolean;
}

export interface OwnProps {
  prozess: IProzessDto;
  recordId: string;
  shouldValidate: boolean;
  setIsValidationError: (isError: boolean) => void;
  funktionId: number;
  fullScreen?: boolean;
}

export interface SelectWithDialogState {
  value: string | string[] | undefined;
  isError: boolean;
  isValid: boolean;
  isProzessEdited?: boolean;
}

export interface SelectWithDialogAction {
  type: SelectWithDialogActionType;
  payload: {
    value: string | string[] | undefined;
    isRequired?: boolean;
    shouldKeepValue?: boolean;
    status: ProzessEventOperationTypes;
    isValid?: boolean;
    isProzessEdited?: boolean;
  };
}

export enum SelectWithDialogActionType {
  INIT,
  PROZESS_DATA_CHANGED,
  RESET,
  PROZESS_DATA_EDITED,
}
